/* eslint-disable */

import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from "react";
import "./customFloatingFilter.css";
import SearchIcon from '@material-ui/icons/Search';

export default forwardRef((props, ref) => {
	const inputRef = useRef(null);
	useImperativeHandle(ref, () => {
		return {
			onParentModelChanged(parentModel) {
				inputRef.current.value = parentModel;
			}
		};
	});

	const onInputBoxChanged = async (input) => {
		props.parentFilterInstance((instance) => {
			setTimeout(() => {
				instance?.componentInstance?.myMethodForTakingValueFromFloatingFilter(input.target.value);
			}, 100);
		});
	};

	const handleSearchButtonClick = () => {
		// console.log("search hit")
		props.parentFilterInstance((instance) => {
			instance?.componentInstance?.handleSearch();
		});
	};

	const handleHitEnter = (event) => {
		if (event.key === "Enter") {
			props.parentFilterInstance((instance) => {
				instance?.componentInstance?.handleSearch();
			});
		}
	};

	const style = {
		color: props.color
	};

	return (
		<div className="inputWithSearchFilter">
			<input
				ref={inputRef}
				className="customFloatingFilter"
				style={style}
				type="text"
				onInput={onInputBoxChanged}
				onKeyDown={handleHitEnter}
			/>
			<button onClick={handleSearchButtonClick} className="searchButton">
				<span>
					<SearchIcon style={{ fontSize: "18px" }} />
				</span>
			</button>
		</div>
	);
});
